import { useSortable } from "@dnd-kit/sortable"
import { CSS } from "@dnd-kit/utilities"
import RenderFormulaQuestion from "./RenderFormulaQuestion"
import RenderFormulaValue from "./RenderFormulaValue"
import RenderFormulaGroup from "./RenderFormulaGroup"
import RenderFormulaFunction from "./RenderFormulaFunction"
import { LogError } from "../../../../../../helpers/logger"
import RenderFormulaOption from "./RenderFormulaOption"

export default function RenderFormula({
  formulaOrder,
  renderAsDragging,
  hideConnector,
  overConnectorId,
}) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id: formulaOrder?.id,
    data: { formulaOrder: formulaOrder },
  })

  if (!formulaOrder?.id) {
    LogError("RenderFormula: formulaOrder or formulaOrder.id is undefined", {
      formulaOrder,
    })
    return <>Unknown formula type</>
  }

  const style = {
    transition,
    opacity: isDragging || renderAsDragging ? 0.5 : undefined,
    transform: CSS.Transform.toString(transform),
  }

  if (formulaOrder.isDeleted) {
    return null
  }

  if (formulaOrder?.question) {
    return (
      <RenderFormulaQuestion
        formulaOrder={formulaOrder}
        dndRef={setNodeRef}
        dndStyle={style}
        dndAttributes={attributes}
        dndListeners={listeners}
        hideConnector={hideConnector}
        overConnectorId={overConnectorId}
      />
    )
  } else if (formulaOrder?.value) {
    return (
      <RenderFormulaValue
        formulaOrder={formulaOrder}
        dndRef={setNodeRef}
        dndStyle={style}
        dndAttributes={attributes}
        dndListeners={listeners}
        hideConnector={hideConnector}
        overConnectorId={overConnectorId}
      />
    )
  } else if (formulaOrder?.group) {
    return (
      <RenderFormulaGroup
        formulaOrder={formulaOrder}
        dndRef={setNodeRef}
        dndStyle={style}
        dndAttributes={attributes}
        dndListeners={listeners}
        hideConnector={hideConnector}
        overConnectorId={overConnectorId}
      />
    )
  } else if (formulaOrder?.function) {
    return (
      <RenderFormulaFunction
        formulaOrder={formulaOrder}
        dndRef={setNodeRef}
        dndStyle={style}
        dndAttributes={attributes}
        dndListeners={listeners}
        hideConnector={hideConnector}
        overConnectorId={overConnectorId}
      />
    )
  } else if (formulaOrder?.option) {
    return (
      <RenderFormulaOption
        formulaOrder={formulaOrder}
        dndRef={setNodeRef}
        dndStyle={style}
        dndAttributes={attributes}
        dndListeners={listeners}
        hideConnector={hideConnector}
        overConnectorId={overConnectorId}
      />
    )
  } else {
    return <>Unknown formula type</>
  }
}
